import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Homepage";
import DrugDetails from "./components/DrugDetail";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import DrugDescription from "./components/Description";


function App() {
  return (
   
   <>
   <BrowserRouter>
       <Header/>

      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/DrugDetails" element={<DrugDetails/>}/>
        <Route path="/AboutUs" element={<AboutUs/>}/>
        <Route path="/Contact" element={<Contact/>}/>
        <Route path="/Description" element={<DrugDescription/>}/>

      </Routes>



   </BrowserRouter>
    </>
  );
}

export default App;
